/**
 * Liste des champs obligatoires pour un stakeholder
 */
export const STAKEHOLDER_REQUIRED_FIELDS = [
  "title",
  "firstName",
  "lastName",
  "citizenshipCountryCode",
  "birthDate",
  "residenceCountryCode",
  "birthCountryCode",
] as const;

/**
 * Type pour les champs requis d'un stakeholder
 */
export type StakeholderRequiredField = (typeof STAKEHOLDER_REQUIRED_FIELDS)[number];
